import { z } from 'zod/v4';

/* Defines the kind of color palette to use.
 * Categorical means we use just cycle through the color based on the series index
 * Consistent means we assign color by the series name and attempt to assign the same color
 * across panels
 */
export type ColorPaletteKind = z.infer<typeof colorPaletteKindSchema>;
export const colorPaletteKindSchema = z
  .enum(['Categorical', 'CategoricalNoErrorColors', 'CategoricalNoStatusColors', 'Consistent'])
  .describe(
    'The kind of color palette to use. Categorical means we use just cycle through the color based on the series index. Consistent means we assign color by the series name and attempt to assign the same color across panels.'
  );
